import React, { useEffect, useState } from 'react';

import { Col, Label, Row } from 'reactstrap';

import Constants from '../../Constants';
import PasswordCheck from '../Common/Errors/PasswordCheck';
import './PasswordStrength.scss';

const { layoutGridSize, formLabelSize, formLabelSizeSm } = Constants;
const validateNewPassword = (value) => {
  const validations = {
    characterLength: PasswordCheck.minCharacterCheck(value),
    lowercase: PasswordCheck.lowercaseCheck(value),
    uppercase: PasswordCheck.uppercaseCheck(value),
    number: PasswordCheck.numberCheck(value),
    specialChar: PasswordCheck.specialcharacter(value),
  };

  const failedLabels = Object.keys(validations)
    .map((validationLabel) => (validations[validationLabel] ? null : validationLabel))
    .filter((v) => !!v);

  return { ...validations, failedLabels };
};

export const PasswordStrength = (props) => {
  const { newPassword, dirty, onState, showErrorMessage, errorMessage, className, hideLabel, labelProps, containerProps, } = props;
  const [pwdCheck, setPwdCheck] = useState(validateNewPassword(newPassword));

  const controlSize = layoutGridSize - formLabelSize;
  const controlSizeSm = layoutGridSize - formLabelSizeSm;

  useEffect(() => {
    const nextState = validateNewPassword(newPassword);
    setPwdCheck(nextState);
    onState ? onState(nextState) : void 0;
  }, [newPassword, dirty]);

  const printErrorMessage = (msg, id) => {
    return (
      <p role="status" id={id} className="password-error" aria-label={msg + ' required.'}>
        <i role="status" className="fa fa-times pRight-10 password-error" aria-label="required"></i>
        {msg}
      </p>
    );
  };

  const printSuccessMessage = (msg, id) => {
    return (
      <p role="status" id={id} aria-label={msg + ' checked.'}>
        <i role="status" className="fa fa-check pRight-10 text-success" aria-label="checked"></i>
        {msg}
      </p>
    );
  };

  const printStaleMessage = (msg, id) => {
    return (
      <p role="status" id={id} aria-label={msg + '.'}>
        {msg}
      </p>
    );
  };

  return (
    <Row className={`v-middle-align pBottom-15 com-password-strength ${className}`.trim()}>
      <Label for="username" className="ScalaSansOT" sm={formLabelSizeSm} md={formLabelSize} hidden={hideLabel} {...(labelProps ||{})} />
      <Col className="input-left" sm={controlSizeSm} md={controlSize} {...(containerProps||{})}>
        <div
          id={`passwordRequirementsList_${btoa(newPassword.replace(/\s/g, ''))}_id`}
          className="passwordRequirements text-left">
          {dirty && pwdCheck.failedLabels.length === 0 ? (
            <p role="status" aria-label="Your new password meets all requirements.">
              Your new password meets all requirements:
            </p>
          ) : (
            <p role="status" aria-label="Your password must meet these minimal requirements.">
              Your password must meet these minimal requirements:
            </p>
          )}
          {(dirty ? (pwdCheck.characterLength ? printSuccessMessage : printErrorMessage) : printStaleMessage)(
            'Minimum of 8 characters',
            'characterLength',
          )}
          {(dirty ? (pwdCheck.lowercase ? printSuccessMessage : printErrorMessage) : printStaleMessage)(
            '1 lowercase letter',
            'lowercase',
          )}
          {(dirty ? (pwdCheck.uppercase ? printSuccessMessage : printErrorMessage) : printStaleMessage)(
            '1 uppercase letter',
            'uppercase',
          )}
          {(dirty ? (pwdCheck.number ? printSuccessMessage : printErrorMessage) : printStaleMessage)(
            '1 number',
            'number',
          )}
          {(dirty ? (pwdCheck.specialChar ? printSuccessMessage : printErrorMessage) : printStaleMessage)(
            '1 special character',
            'specialChar',
          )}
        </div>
        {showErrorMessage ? (
          <div className="lsn-form-item-error height-25 v-align-top">
            <span id="password_strength_error" role="alert" className="input-error">
              {errorMessage}
            </span>
          </div>
        ) : null}
      </Col>
    </Row>
  );
};

export default PasswordStrength;
